export default [
  {
    path: '/popup/:name/:id?',
    name: 'detailPopup',
    component: () => import(/*webpackChunkName:'detail'*/ '@/pages/DetailPopup.vue'),
    meta: {},
  },
  {
    path: '/drilldown-report/:command?/:id?',
    name: 'drilldownReport',
    component: () => import(/*webpackChunkName:'detail'*/ '@/pages/DrillDownReportPage.vue'),
    meta: {},
  },
  {
    path: '/500',
    name: '500',
    component: () => import(/*webpackChunkName:'pages'*/ '@/pages/404.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/403',
    name: '403',
    component: () => import(/*webpackChunkName:'pages'*/ '@/pages/403.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/*webpackChunkName:'pages'*/ '@/pages/404.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/login-code',
    name: 'LoginCode',
    component: () => import(/*webpackChunkName:'login'*/ '@/pages/LoginCode.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/login-callback',
    name: 'LoginCallback',
    component: () => import(/*webpackChunkName:'login'*/ '@/pages/LoginCallback.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/*webpackChunkName:'login'*/ '@/pages/Login.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import(/*webpackChunkName:'logout'*/ '@/pages/Logout.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/dictionary/create-data',
    name: 'create-data',
    component: () => import('@/views/dictionary/dataManagement/CreateData.vue'),
    meta: {},
  },
  {
    path: '/dictionary/create-data-prev-year',
    name: 'create-data-prev-year',
    component: () => import('@/views/dictionary/dataManagement/createDataPrevYear/CreateDataPrevYear.vue'),
    meta: {},
  },
  {
    path: '/system/create-data-tenant',
    name: 'create-data-tenant',
    component: () => import('@/views/system/CreateDataTenant.vue'),
    meta: {},
  },
  {
    path: '/system/getting-method',
    name: 'getting-method',
    component: () => import('@/views/system/MethodGetting.vue'),
    meta: {},
  },

  {
    path: '/dictionary/expire-date',
    name: 'expire-date',
    component: () => import('@/views/dictionary/license/ExpireDate.vue'),
    meta: {},
  },
  {
    path: '/choose-tenant',
    name: 'choose-tenant',
    component: () => import('@/views/system/ChooseTenant.vue'),
    meta: {},
  },
  {
    path: '/dictionary/warning-date',
    name: 'warning-date',
    component: () => import('@/views/dictionary/license/WarningDate.vue'),
    meta: {},
  },
  {
    path: '/login-callback-desktop/:port',
    name: 'login-callback-desktop',
    component: () => import('@/views/convert/ConvertData.vue'),
    meta: {},
  },
  {
    path: '/confirmRedirect',
    name: 'confirm-redirect',
    component: () => import('@/pages/ConfirmRedirect.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/upgrading',
    name: 'upgrading',
    component: () => import(/*webpackChunkName:'pages'*/ '@/pages/Upgrading.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/maintaining',
    name: 'maintaining',
    component: () => import(/*webpackChunkName:'pages'*/ '@/pages/Maintaining.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/2fa-login',
    name: '2falogin',
    component: () => import('@/views/system/TwoFactorAuthentication.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/verify-email',
    name: 'verifyemail',
    component: () => import('@/views/system/VerifyInformation.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/verify-phone',
    name: 'verifyphone',
    component: () => import('@/views/system/VerifyInformationPhone.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/change-password',
    name: 'changepassword',
    component: () => import('@/views/system/ChangePassword.vue'),
    meta: {
      anonymous: true,
    },
  },

  {
    path: '/rp',
    name: 'unregisterserviceother',
    component: () => import('@/pages/UnregisterService.vue'),
    meta: {
      anonymous: true,
    },
  },

  {
    path: '/opening-database',
    name: 'openingdatabase',
    component: () => import('@/pages/OpeningDatabase.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/show-update-tt23',
    name: 'showUpdateTT23',
    component: () => import('@/pages/ShowUpdateTT23.vue'),
    meta: {
      anonymous: true,
    },
  },
];
